<template>
  <div>
    <h1 class="mb-2 font-regular ml-n1">Balances</h1>
    <div class="row">
      <div
        class="col-xl-3 col-lg-6 col-12 px--5"
        v-for="provider in providers"
        :key="provider.key"
      >
        <CCard
          :bgColor="activeColor"
          :textColor="textColor"
          :text="provider.label"
          :value="provider.loading ? '...' : provider.balance"
          :valueColor="valueColor"
          :cardImg="transactionIcon"
          :currency="provider.currency"
        />
      </div>
    </div>

    <div class="card card--no-shadow mt-4">
      <div class="card-header">
        <h4 class="card-title mb-0">Account Balances</h4>
        <small class="text-muted">
          Accounts listed in General Settings (Display Account Numbers).
        </small>
      </div>
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th>Account Number</th>
                <th>Account Name</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="account in accounts" :key="account.account_number">
                <td>{{ account.account_number }}</td>
                <td>
                  {{ account.loading ? "Loading..." : account.account_name || "—" }}
                </td>
                <td>
                  <span v-if="account.loading">...</span>
                  <span v-else>₦{{ formatBalance(account.balance) }}</span>
                </td>
              </tr>
              <tr v-if="accountsLoading">
                <td colspan="3" class="text-center text-muted py-4">
                  Loading account numbers...
                </td>
              </tr>
              <tr v-else-if="accounts.length === 0">
                <td colspan="3" class="text-center text-muted py-4">
                  No display accounts configured in General Settings.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CCard from "@/components/CCard";
import ApiService from "@/services/api.service";
import transactionIcon from "@/assets/images/transaction-icon.png";

export default {
  name: "Balance",
  components: {
    CCard
  },
  data() {
    return {
      activeColor: "#2CB858",
      textColor: "#001833",
      valueColor: "#001833",
      transactionIcon,
      providers: [
        {
          key: "vtpass",
          label: "VT Pass",
          balance: "0",
          loading: true,
          currency: true
        },
        {
          key: "shago",
          label: "Shago",
          balance: "0",
          loading: true,
          currency: true
        },
        {
          key: "phlex",
          label: "Phlex",
          balance: "0",
          loading: true,
          currency: false
        },
        {
          key: "you-verify",
          label: "You Verify",
          balance: "0",
          loading: true,
          currency: false
        }
      ],
      accounts: [],
      accountsLoading: false
    };
  },
  methods: {
    formatBalance(value) {
      const amount = Number(value);
      if (Number.isNaN(amount)) {
        return value || "0.00";
      }
      return amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    async loadProvider(provider) {
      try {
        const response = await ApiService.get(
          `settings/balances/${provider.key}`
        );
        provider.balance = response.data.data.balance;
      } catch (error) {
        provider.balance = "no-response";
      } finally {
        provider.loading = false;
      }
    },
    async loadAccount(account) {
      try {
        const response = await ApiService.get(
          `settings/balances/account/${account.account_number}`
        );
        const data = response.data.data;
        account.account_name = data.account_name;
        account.balance = data.balance;
      } catch (error) {
        account.account_name = "Unavailable";
        account.balance = 0;
      } finally {
        account.loading = false;
      }
    },
    async loadAccounts() {
      this.accountsLoading = true;
      this.accounts = [];
      try {
        const response = await ApiService.get("settings/balances/accounts");
        const accountNumbers = response.data.data || [];
        this.accounts = accountNumbers.map(accountNumber => ({
          account_number: accountNumber,
          account_name: "",
          balance: 0,
          loading: true
        }));
        this.accounts.forEach(account => this.loadAccount(account));
      } catch (error) {
        this.accounts = [];
      } finally {
        this.accountsLoading = false;
      }
    }
  },
  mounted() {
    this.providers.forEach(provider => this.loadProvider(provider));
    this.loadAccounts();
  }
};
</script>

<style>
.px--5 {
  padding-right: 5px;
  padding-left: 5px;
}
</style>
